import {
  Button,
  Col,
  Collapse,
  Descriptions,
  Divider,
  Input,
  Modal,
  Row,
  Space,
  Table,
} from 'antd';
import { InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import Excel from 'components/table/excel';
import CustomPagination from 'components/table/pagination';
import DashboardContext from 'Context';
import InputControl from 'components/inputs/InputControl';
import InputDate from 'components/inputs/InputDate';
import InputNumber from 'components/inputs/InputNumber';
import InputControlMulti from 'components/inputs/InputControlMulti';

export default function NewCustomersReport() {
  const { urldashboard, authentication } = useContext(DashboardContext);

  // table data
  const [data, setData] = useState([]);
  const [record, setRecord] = useState({});
  const [formData, setFormData] = useState({
    profileBusinessType: null,
  });
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [moreInfoModal, setMoreInfoModal] = useState(false);

  useEffect(() => {
    getNewCustomersReport({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
      searchValue,
      formData,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getNewCustomersReport = async ({
    page,
    pageSize,
    searchValue,
    formData,
  }) => {
    setLoading(true);
    try {
      let url = '/newCustomerReport/get';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({
          page,
          pageSize,
          customerName: searchValue,
          ...formData,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      const items = data?.data?.map((obj) => ({
        ...obj,
        key: obj.id,
      }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getNewCustomersReport({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
      formData,
    });
  };

  const search = () => {
    getNewCustomersReport({
      page: 1,
      pageSize: 10,
      searchValue,
      formData,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نام مشتری',
      dataIndex: 'customerName',
      key: 'customerName',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'تاریخ ثبت‌نام',
      dataIndex: 'registerDate',
      key: 'registerDate',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'شماره تلفن',
      dataIndex: 'cellPhone',
      key: 'cellPhone',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'نحوه آشنایی',
      dataIndex: 'referrerName',
      key: 'referrerName',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'تعداد سفارش',
      dataIndex: 'orderCount',
      key: 'orderCount',
      responsive: ['xl', 'lg', 'md', 'sm'],
    },
    {
      title: 'ایجادکننده',
      dataIndex: 'creatorName',
      key: 'creatorName',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'نحوه ثبت‌نام',
      dataIndex: 'createMode',
      key: 'createMode',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => {
        return {
          props: {
            style: {
              backgroundColor: value === 'آفلاین' ? "#d6cdcd" : "#acbdff"
            }
          },
          children: value ?? '-'
        };
      },
    },
    {
      title: 'اطلاعات بیشتر',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => showInfoModal(record)}>
          <i className='mdi mdi-eye'></i>
        </Button>
      ),
    },
  ];

  // actions

  const showInfoModal = (data) => {
    setRecord(data);
    setMoreInfoModal(true);
  };

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <Collapse defaultActiveKey={['0']}>
            <Collapse.Panel header='جستجو پیشرفته' key='1'>
              {/* */}
              <Row gutter={20}>
                <Col
                  xl={formData?.profileBusinessType !== null ? 6 : 8}
                  lg={6}
                  md={12}
                  sm={12}
                  xs={24}
                >
                  <InputDate
                    label='ثبت‌نام از تاریخ'
                    name='fromDate'
                    handelValue={(_, value) =>
                      setFormData({
                        ...formData,
                        fromDate: value,
                      })
                    }
                  />
                </Col>
                <Col
                  xl={formData?.profileBusinessType !== null ? 6 : 8}
                  lg={6}
                  md={12}
                  sm={12}
                  xs={24}
                >
                  <InputDate
                    label='ثبت‌نام تا تاریخ'
                    name='toDate'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, toDate: value })
                    }
                  />
                </Col>
                <Col
                  xl={formData?.profileBusinessType !== null ? 6 : 8}
                  lg={6}
                  md={12}
                  sm={12}
                  xs={24}
                >
                  <InputControl
                    url='/common/profileBusinessTypeDropdown'
                    label='نوع بیزینس کار نیرو'
                    name='profileBusinessType'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, profileBusinessType: value })
                    }
                  />
                </Col>
                {formData?.profileBusinessType !== null && (
                  <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                    <InputControlMulti
                      name='groupIds'
                      url={`/group/dropdownForExpertPost/${formData?.profileBusinessType}`}
                      defaultValue={record.groupIds}
                      label='نوع خدمت'
                      handelValue={(_, value) =>
                        setFormData({ ...formData, groupIds: value })
                      }
                    />
                  </Col>
                )}
              </Row>
              {/* */}
              <Row gutter={20}>
                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <InputNumber
                    label='تعداد سفارش بیشتر از'
                    name='orderCount'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, orderCount: value })
                    }
                  />
                </Col>
                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <InputNumber
                    label='شماره تلفن'
                    name='cellPhone'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, cellPhone: value })
                    }
                  />
                </Col>
                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <InputControlMulti
                    name='referrerIds'
                    url='/referrer/dropdown'
                    label='نحوه آشنایی'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, referrerIds: value })
                    }
                  />
                </Col>
              </Row>
              {/* */}
              <Row
                gutter={20}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: 20,
                }}
              >
                <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                  <Button
                    type='primary'
                    style={{ width: '100%' }}
                    loading={loading}
                    onClick={() => search()}
                  >
                    جستجو
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      </div>

      <Row
        gutter={20}
        style={{
          marginTop: 25,
        }}
      >
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <InputGroup>
            <Input
              placeholder='جستجوی سریع (نام مشتری)'
              name='searchValue'
              onChange={(e) => setSearchValue(e.target.value)}
              style={{
                height: '3rem',
                width: '90%',
                display: 'table-cell',
              }}
            />
            <Button
              onClick={search}
              style={{
                height: '3rem',
                width: '10%',
                display: 'table-cell',
                padding: 0,
              }}
            >
              <i className='mdi mdi-magnify'></i>
            </Button>
          </InputGroup>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <Space
            wrap
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Excel
              server
              fileName={'گزارش_مشتریان_جدید'}
              url={'/newCustomerReport/getExcel'}
              props={{
                ...formData,
                searchValue,
                page: pagination?.page,
                pageSize: pagination?.pageSize,
              }}
            />
          </Space>
        </Col>
      </Row>

      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 10 }}
        rowClassName={() => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        pagination={false}
        locale={{
          emptyText: (
            <h1
              style={{
                color: 'rgba(0, 0, 0, 0.15)',
                padding: '1rem 0',
              }}
            >
              لطفا تاریخ ابتدایی و انتهایی ثبت‌نام را برای شروع جستجو انتخاب
              کنید.
            </h1>
          ),
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
        />
      )}

      <Modal
        title='اطلاعات بیشتر'
        closable={false}
        open={moreInfoModal}
        onCancel={() => setMoreInfoModal(false)}
        footer={[
          <Button key='back' onClick={() => setMoreInfoModal(false)}>
            بستن
          </Button>,
        ]}
        bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
      >
        <Descriptions bordered column={1} size={'small'}>
          <Descriptions.Item label='نام مشتری'>
            {record?.customerName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='ایجادکننده'>
            {record?.creatorName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تاریخ ثبت‌نام'>
            {record?.registerDate ? record?.registerDate : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='شماره تلفن'>
            {record?.cellPhone ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='نحوه آشنایی'>
            {record?.referrerName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تعداد سفارش'>
            {record?.orderCount}
          </Descriptions.Item>
          <Descriptions.Item label='نحوه ثبت‌نام'>
            {record?.createMode ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          {record?.orderCount && (
            <Descriptions.Item label='لیست سفارشات'>
              {record?.orders?.map((order, index) => (
                <div key={index}>
                  <span>{`${order?.groupTitle}`}</span>
                  <Divider type='vertical' />
                  <span>{`تعداد: ${order?.numberOfOrder}`}</span>
                  <Divider type='vertical' />
                  <span>
                    <i className='mdi mdi-calendar-range'></i>{' '}
                    {`${order?.date}`}
                  </span>
                </div>
              ))}
            </Descriptions.Item>
          )}
        </Descriptions>
      </Modal>
    </>
  );
}
